import React from "react";

/* img imports */
import blogsBoard from "../assets/images/blogs-board.png";

const BlogsBoard = ({ handleRedirect }) => {
  return (
    <>
      <div
        className="blogs-board-wrapper"
        onClick={() => {
          handleRedirect("https://medium.com/@tinyviva.kids");
        }}
      >
        <img src={blogsBoard} alt="" />
      </div>
    </>
  );
};

export default BlogsBoard;
